import React from 'react'
import { googleLogout } from '@react-oauth/google'

const Logout = ({ setIsLogin }) => {
  const handleLogout = () => {
    googleLogout(); // clears GIS session state, disables auto sign-in next time
    setIsLogin(false);
    localStorage.removeItem('cafeuser');
    localStorage.removeItem('token');
    console.log("logout success");
  }

  return (
    <div id='signInButton'>
      <button
        onClick={handleLogout}
        className="custom-google-logout-button"
      >
        Logout
      </button>
    </div>
  )
}

export default Logout